<app-loader *ngIf="pageLoader"></app-loader>
<app-error-message *ngIf="errorMessage" (try)="tryAgain()"></app-error-message>
<div class="container" *ngIf="!pageLoader && data">
  <h2 class="text-center">Control de versiones plantillas</h2>
  <div class="rp-tableST">
    <table mat-table [dataSource]="data" class="custom_tableST text-center">
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Fecha </th>
        <td mat-cell *matCellDef="let element"> {{ element.registerDate }} </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Versión </th>
        <td mat-cell *matCellDef="let element"> {{ element.version }} </td>
      </ng-container>

      <ng-container matColumnDef="plantilla">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Plantilla </th>
        <td mat-cell *matCellDef="let element"> {{ element.name.toUpperCase() }} </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Estado </th>
        <td mat-cell *matCellDef="let element"> {{ element.status || " - "}} </td>
      </ng-container>

      <ng-container matColumnDef="ambiente">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Ambiente </th>
        <td mat-cell *matCellDef="let element"> {{ element.environment }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <app-paginator [totalPages]="totalPages" [totalElements]="totalElements" (change)="newRequest()" *ngIf="data.length > 0"></app-paginator>
</div>
